<template>
  <app-modal v-model="open" :title="t('portal_demo.contact_title')" :close-label="t('portal_demo.continue')" data-test="demo-contact-modal">
    <p v-if="sent" role="status" class="text-sm text-theme-text">{{ t('portal_demo.contact_success') }}</p>
    <form v-else class="space-y-4" @submit.prevent="submit">
      <p class="text-sm text-theme-text-secondary">{{ t('portal_demo.contact_body') }}</p>
      <app-input v-model="email" name="demo-email" type="email" autocomplete="email" :label="t('general_email')" required maxlength="254" :disabled="busy" />
      <input v-model="website" name="website" class="hidden" tabindex="-1" aria-hidden="true" autocomplete="off" />
      <p class="text-xs text-theme-text-secondary">{{ t('portal_demo.contact_consent') }} <a :href="privacyUrl" target="_blank" rel="noopener noreferrer" class="underline">{{ t('website.common.privacy') }}</a></p>
      <p v-if="error" role="alert" class="text-sm text-theme-text">{{ error }}</p>
      <div class="flex flex-wrap gap-2">
        <app-button type="submit" :label="t('portal_demo.contact_submit')" tone="primary" variant="solid" :loading="busy" :disabled="busy" />
        <app-button :label="t('portal_demo.continue')" variant="ghost" @click="open = false" />
      </div>
    </form>
  </app-modal>
</template>

<script setup>
  import { ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import AppButton from '@/components/ui/buttons/AppButton.vue';
  import AppInput from '@/components/ui/forms/AppInput.vue';
  import AppModal from '@/components/ui/overlays/AppModal.vue';
  import EmailRepository from '@/repositories/EmailRepository';
  import { recordDemoVisit } from '@/storage/demoMode';
  import { privacyUrl } from '@/website/domain/config';

  const route = useRoute();
  const { t } = useI18n();
  const open = ref(false);
  const sent = ref(false);
  const busy = ref(false);
  const email = ref('');
  const website = ref('');
  const error = ref('');
  let requestId = '';

  function openContact() {
    open.value = true;
  }

  async function submit() {
    if (busy.value) return;
    busy.value = true;
    error.value = '';
    requestId ||= crypto.randomUUID();
    try {
      const { data } = await EmailRepository.requestDemoContact({ email: email.value, website: website.value, requestId });
      if (data?.status !== 'success') throw new Error('request');
      sent.value = true;
    } catch {
      error.value = t('portal_demo.contact_error');
    } finally { busy.value = false; }
  }

  watch(email, () => { requestId = ''; });
  watch(() => route.path, path => {
    if (recordDemoVisit(path)) openContact();
  }, { immediate: true });
</script>
